module.exports = __webpack_public_path__ + "static/media/invalid.a705e232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/invalid.png
// module id = 263
// module chunks = 0